import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../../ReactComponent';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography
} from '@mui/material';
import { AddCircle, Edit, Delete, Cancel } from '@mui/icons-material';
import AutoTextoForm from './AutoTextoForm';
import { grey } from '@mui/material/colors';

const estiloBotoes = { minWidth: 'auto', pl: 0, pr: 1.5 };

class AutoTextoOpcoes extends ReactComponent {
    openFormularioDialog = false;
    tipoFormulario;
    dadosFormulario;

    constructor(props) {
        super(props);

        makeObservable(this, {
            openFormularioDialog: observable,
            tipoFormulario: observable,
            dadosFormulario: observable,
            opcoes: computed,
            temOpcoes: computed,
            handleOpenFormularioDialog: action,
            handleCloseFormularioDialog: action,
            handleCadastrar: action,
            handleEditar: action,
            handleExcluir: action
        });
    }

    get opcoes() {
        return this.preSessaoStore.autoTexto.map((item) => ({
            valor: item.autoTexto,
            texto: item.nomeAutoTexto,
            id: item.id
        }));
    }

    get temOpcoes() {
        return this.opcoes && this.opcoes.length > 0;
    }

    handleOpenFormularioDialog = () => {
        this.openFormularioDialog = true;
    };

    handleCloseFormularioDialog = () => {
        this.openFormularioDialog = false;
        this.preSessaoStore.carregarAutoTexto();
    };

    handleCadastrar = () => {
        this.handleOpenFormularioDialog();
        this.tipoFormulario = 'cadastrar';
        this.dadosFormulario = {};
    };

    handleEditar = (opcao) => {
        this.handleOpenFormularioDialog();
        this.tipoFormulario = 'editar';
        this.dadosFormulario = opcao;
    };

    handleExcluir = (opcao) => {
        this.handleOpenFormularioDialog();
        this.tipoFormulario = 'excluir';
        this.dadosFormulario = opcao;
    };

    render() {
        return (
            <>
                <Dialog
                    open={true}
                    onClose={this.observableProps.handleCloseDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth="lg"
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mr: 5 }}>
                        <DialogTitle id="alert-dialog-title">Gestão de opções do Dec-Pad</DialogTitle>
                        <Button
                            variant="contained"
                            sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
                            onClick={this.handleCadastrar}
                            endIcon={<AddCircle sx={{ fontSize: 20 }} />}
                        >
                            <Typography>Cadastrar nova opção</Typography>
                        </Button>
                    </Box>
                    <DialogContent>
                        {this.temOpcoes ? (
                            <TableContainer component={Paper}>
                                <Table aria-label="Gestão de opções do Dec-Pad">
                                    <TableHead sx={{ background: grey[300] }}>
                                        <TableRow>
                                            <TableCell
                                                sx={{
                                                    textAlign: 'center',
                                                    borderRight: '1px solid rgba(204, 204, 204, 1)'
                                                }}
                                            >
                                                Código
                                            </TableCell>
                                            <TableCell
                                                sx={{
                                                    textAlign: 'center',
                                                    borderRight: '1px solid rgba(204, 204, 204, 1)'
                                                }}
                                            >
                                                Conteúdo
                                            </TableCell>
                                            <TableCell
                                                sx={{
                                                    textAlign: 'center'
                                                }}
                                            >
                                                Ações
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.opcoes.map((opcao) => (
                                            <TableRow
                                                key={opcao.id}
                                                sx={{
                                                    borderBottom: '1px solid rgba(224, 224, 224, 1)',
                                                    '&:nth-of-type(odd)': {
                                                        backgroundColor: grey[100]
                                                    },
                                                    '&:last-child td, &:last-child th': { borderBottom: 0 }
                                                }}
                                            >
                                                <TableCell
                                                    sx={{
                                                        textAlign: 'center',
                                                        border: 0,
                                                        borderRight: '1px solid rgba(224, 224, 224, 1)'
                                                    }}
                                                >
                                                    {opcao.texto}
                                                </TableCell>
                                                <TableCell
                                                    sx={{ border: 0, borderRight: '1px solid rgba(224, 224, 224, 1)' }}
                                                >
                                                    {opcao.valor}
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        gap: 1,
                                                        border: 0
                                                    }}
                                                >
                                                    <Tooltip
                                                        title="Editar opção"
                                                        placement="top-start"
                                                    >
                                                        <Button
                                                            onClick={() => this.handleEditar(opcao)}
                                                            endIcon={<Edit />}
                                                            sx={estiloBotoes}
                                                        />
                                                    </Tooltip>

                                                    <Tooltip
                                                        title="Excluir opção"
                                                        placement="top-start"
                                                    >
                                                        <Button
                                                            onClick={() => this.handleExcluir(opcao)}
                                                            endIcon={<Delete />}
                                                            sx={estiloBotoes}
                                                            color="secondary"
                                                        />
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        ) : (
                            <Box>Não existem opções disponíveis.</Box>
                        )}
                    </DialogContent>
                    <DialogActions sx={{ display: 'flex', justifyContent: 'space-between', mx: 2 }}>
                        <Button
                            color="secondary"
                            onClick={this.observableProps.handleCloseDialog}
                            variant="outlined"
                            data-testid="closeDialog"
                            endIcon={<Cancel />}
                        >
                            Fechar
                        </Button>
                    </DialogActions>
                </Dialog>
                {this.openFormularioDialog && (
                    <AutoTextoForm
                        tipo={this.tipoFormulario}
                        id={this.dadosFormulario?.id}
                        codigo={this.dadosFormulario?.texto}
                        conteudo={this.dadosFormulario?.valor}
                        handleCloseDialog={this.handleCloseFormularioDialog}
                    />
                )}
            </>
        );
    }
}

export default inject('stores')(observer(AutoTextoOpcoes));
